// extracted by mini-css-extract-plugin
export default {"root":"BaseDrawer_root__Dx1Xc","body":"BaseDrawer_body__g1xSV","slate":"BaseDrawer_slate__++05Q"};